const Builder = require('../BuilderBase');

module.exports = class ActionAfterScan extends Builder {
    constructor(properties) {
        super('transform_ActionAfterScan', '', properties);
    }
};
